export {
  processSubjectOptions,
  SUBJECT_ORDERING,
  SEL_CATEGORY_ORDERING,
  READING_DOMAIN_ORDERING,
  ELD_DOMAIN_ORDERING,
  ALGOLIA_BYTE_LIMIT,
  isQueryTooLong,
  TRUNCATED_LIMIT,
}

function processSubjectOptions(subjects, isTeks) {
  var teksVariationSubjects = ['Reading', 'Writing', 'Math']

  return subjects
    .map(subject => {
      return subject.key
    })
    .filter(subject => {
      if (isTeks && teksVariationSubjects.indexOf(subject) === -1) {
        return true
      } else if (!isTeks && subject.indexOf('TEKS') === -1) {
        return true
      }
      return false
    })
}

const SUBJECT_ORDERING = [
  'Reading TEKS',
  'Writing TEKS',
  'Math TEKS',
  'Reading',
  'Writing',
  'Math',
  'Behavior & SEL',
  'Pre-Academics',
  'English Learners',
  'Autism',
  'Speech & Language',
  'HS Transition',
  'Executive Functioning'
]

const SEL_CATEGORY_ORDERING = [
  'Self-Awareness',
  'Self-Management',
  'Social Awareness',
  'Relationship Skills',
  'Responsible Decision Making'
]

const READING_DOMAIN_ORDERING = [
  'Concepts of Print',
  'Phonics & Decoding',
  'Fluency',
  'Comprehension: Literature',
  'Comprehension: Informational Text'
]

const ELD_DOMAIN_ORDERING = ['Reading', 'Writing', 'Listening', 'Speaking']

const ALGOLIA_BYTE_LIMIT = 512
const calculateBytesInString = string => new Blob([string]).size
const isQueryTooLong = (string, byteLimit = ALGOLIA_BYTE_LIMIT) => calculateBytesInString(string) > byteLimit
const TRUNCATED_LIMIT = 450